<template>
<div>
  <div>
    <div>
      <span class="title">Selecione a data</span>
    </div> 
    <div
      class="container-input mt-2"
      :class="{'container-input-max' : availableDates.length == 1}">
      <div>
        <i v-if="availableDates.length <= 0">Nenhuma data disponível</i>
        <span
          v-else-if="availableDates.length == 1"
          style="color: #FFF;">
          <div>{{ dataFormatada }}</div>
          <div style="font-size: 10px;">{{ diaFormt }}</div>
        </span>
      </div>
      <div
        v-if="availableDates.length > 1"
        class="d-flex align-items-center justify-content-between flex-wrap">
        <button
          v-if="dates.length > 4 && !isMobile" 
          class="btn btn-link p-0"
          :disabled="currentIndex === 0"
          @click="navigate(-1)">
          <i class="fas fa-chevron-left" />
        </button>
        <div
          ref="datesContainer"
          class="d-flex cointaner-date">
          <div
            v-for="(date, index) in visibleDates"
            :key="date.id"
            :class="{ 'input-date' : true, 'input-date-active': currentIndex === index + startIndex }"
            @click="setDay(date.date, index, startIndex)">
            <div class="date-body">
              <div class="header-input-date">
                <span :class="{'date': true, 'text-active' : currentIndex === index + startIndex}">
                  {{ date.day }}
                </span> 
                <span :class="{'text-active' : currentIndex === index + startIndex}"> {{ date.month }}</span>
              </div>
              <div :class="{'input-date-text': true, 'text-active' : currentIndex === index + startIndex}">
                {{ date.weekday }}
              </div>
            </div>
          </div>
        </div>
        <button
          v-if="!isMobile"
          class="btn btn-link p-0"
          :disabled="startIndex + 4 >= dates.length"
          @click="navigate(1)">
          <i class="fas fa-chevron-right" />
        </button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import moment from 'moment';
export default {
    name:'InputDataCalendarioEvento',
    props: {
        value: {
            validator: (v) => v instanceof Date || v == null,
            default: () => null,
            required: false
        },
        initialAvailableDays: {
            type: String,
            default: () => '[]',
            required: false
        },
        passeioId: {
            type:[String, Number],
            default: () => 0,
            required: false
        },
        isMobile: {
            type: Boolean,
            default: () => false,
            required: false
        },
    },
    emits: ['input'],
    data() {
        return {
            currentIndex: null,
            startIndex: 0,
            dates: [],
            availableDates: JSON.parse(this.$props.initialAvailableDays),
            startDate: new Date,

        };
    },
    computed: {
        dataFormatada() {
            if(!this.$props.value) {
                return;
            }
            let mes = this.$props.value.toLocaleDateString('pt-BR', { month: 'short' });
            mes = mes.substring(0, 3).toUpperCase();
            const dia = this.$props.value.toLocaleDateString('pt-BR', { day: 'numeric' });
            const year = this.$props.value.toLocaleDateString('pt-BR', { year: 'numeric' });
            return `${dia} ${mes} - ${year}`;

        },
        diaFormt(){
            if(!this.$props.value) {
                return;
            }
            const diaSemana = this.$props.value.toLocaleDateString('pt-BR', { weekday: 'long' }); 
            return diaSemana.toUpperCase();
        },
        availableDatesParsed() {
            return this.availableDates.map(raw => {
                const parts = raw.split('-');
                return new Date(parts[0], parts[1]-1, parts[2], 0, 0, 0, 0);
            });
        },
        visibleDates() {
            if(this.$props.isMobile){
                return this.dates;   
            }
            return this.dates.slice(this.startIndex, this.startIndex + 4);
        },
    },
    created() {
        if(!this.availableDates || this.availableDates.length <= 0) {
            return;
        }
        this.startDate = this.toStrigDate(this.availableDates[0]);
        this.setDates();
        if(this.availableDates.length === 1 && this.startDate)
        {
            this.emitEvent(this.startDate);
        }

        if(this.$props.isMobile){
            const container = this.$refs.datesContainer;

            container.addEventListener('touchstart', this.handleTouchStart);
            container.addEventListener('touchend', this.handleTouchEnd);
        }
    },
    methods: {
        setDates() {
            if(this.availableDates.length === 0) {
                return [];
            }

            this.dates = this.availableDates.map((dateString, index) => {
                const date = moment(dateString, 'YYYY-MM-DD');
    
                const mes = date.format('MMM').toUpperCase();
                const dia = date.format('D');
                const weekday = date.format('dddd').toUpperCase();

                return {
                    id: index + 1,
                    date: dateString,
                    day: dia,
                    month: mes,
                    weekday: weekday,
                };
            });
        },
        navigate(direction) {
            const newStartIndex = this.startIndex + direction;
            if (newStartIndex >= 0 && newStartIndex + 4 <= this.dates.length) {
                this.startIndex = newStartIndex;
            }
        },
        setDay(date, index, startIndex){
            this.currentIndex = index + startIndex;
            const value  =  this.toStrigDate(date);
            this.emitEvent(value);
        },
        toStrigDate(date){
            if(!date){
                return null;
            }
            const parts = date.split('-');
            return new Date(parts[0], parts[1]-1, parts[2], 0, 0, 0, 0);
        },
        emitEvent(value){
            if(!value){
                return null;
            }
            this.$emit('input',  value);
        },
        handleTouchStart(evt) {
            this.touchStartX = evt.changedTouches[0].screenX;
        },
        handleTouchEnd(evt) {
            const touchEndX = evt.changedTouches[0].screenX;
            const diffX = this.touchStartX - touchEndX;

            if (diffX > 50) { // swipe left
                this.navigate(1);
            } else if (diffX < -50) { // swipe right
                this.navigate(-1);
            }
        }
    }
};
</script>
  
  <style scoped>
  .btn{
    color: #464646;
    font-size: 10px;
  }
  .input-date {
    border-radius: 5px;
    border: 1px solid #D3D3D3;
    background: #FFF;
    width: 101px;
    height: 65px;
    flex-shrink: 0;
    margin: 0.25rem;
    cursor: pointer; 
    color: #464646;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .input-date-active {
    border-width: 2px;
    background: #E88A1D;
    width: 101px;
    height: 65px;
    flex-shrink: 0;
    border: 1px solid #E88A1D;
  }
  .text-active{
    color: #FFF !important;
  }
  .title{
    color: #464646;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .header-input-date {
    color: #464646;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
    display: flex !important;
    justify-content: center;
}
.date{
    color: #E88A1D;
    margin-right: 5px;
}

.date-body{
    padding-left: 1rem;
    padding-top: 0.6rem;
    padding-right: 1rem;
}
.input-date-text{
    color: #7D7D7D;
    text-align: center;
    font-family: Poppins;
    font-size: 8px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
}

.container-input-max {
    width: 100%;
    border: 0px;
    background-color: #E88A1D;
    border-radius: 5px;
    padding: 15px;
    color: #fff;
    cursor: pointer;
    font-weight: 600;
} 

.cointaner-date {
  overflow-x: hidden;
}

@media (max-width: 768px) {
    /* Estilo para dispositivos móveis */
    .cointaner-date {
        overflow-x: scroll;
        scroll-snap-type: x mandatory;
        -ms-overflow-style: none; /* IE e Edge */
        scrollbar-width: none; /* Firefox */
        width: 100%;
    }
    .container-date::-webkit-scrollbar {
    display: none;
}
    .input-date {
        scroll-snap-align: center;
        height: 65px;
        
    }
}


  </style>
  